import { CampaignTypes } from 'features/Codes'

// 선택된 캠페인(selectedIds) 중 톡채널검색(TALK_CHANNEL) 유형이 하나라도 있으면 true.
// content 는 대시보드 캠페인 테이블 row 배열이며 각 row 는 { id, type } 를 가진다.
export const hasTalkChannelCampaign = (content, selectedIds) =>
  content.some(
    ({ id, type }) =>
      selectedIds.includes(id) && type === CampaignTypes.TALK_CHANNEL
  )

// 톡채널검색 캠페인이 포함된 상태에서 "연동하지 않기"(conversionTrackingId === null)로
// 변경하려는 경우 차단해야 한다.
export const shouldBlockConversionTrackingRemoval = (
  hasTalkChannel,
  conversionTrackingId
) => hasTalkChannel && conversionTrackingId === null
